import React, { useEffect, useState } from "react";
// Chakra imports
import {
  Box,
  Button,
  Flex,
  Grid,
  Text,
  Spacer,
  FormControl,
  FormLabel,
  Select,
  Input,
  Progress,
  Switch,
  Alert,
  AlertIcon,
  useDisclosure,
  useColorModeValue,
} from "@chakra-ui/react";
// Custom components
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import BarChart from "components/Charts/BarChart";
import LineChart from "components/Charts/LineChart";
import IconBox from "components/Icons/IconBox";
import EstimateMechanic from "views/Custom/EstimateMechanic";
import EstimateService from "views/Custom/EstimateService";
import CustomizeService from "views/Custom/CustomizeService";
import ViewEstimate from "../../modals/ViewEstimate";
import CreateOrder from "../../modals/CreateOrder";
import { useAuth } from "contexts/auth";
import { saveDraft, clearDraft } from "reducers/draft";

export default function EstimateOrder() {

  const { draft, draftDispatch } = useAuth();
  const { isOpen: isOpenCreate, onOpen: onOpenCreate, onClose: onCloseCreate } = useDisclosure();
  const { isOpen: isOpenViewEstimate, onOpen: onOpenViewEstimate, onClose: onCloseViewEstimate } = useDisclosure();
  const [ orderData, setOrderData ] = useState(null);

  const [ carMake, setCarMake ] = useState('');
  const [ carType, setCarType ] = useState('');
  const [ carYear, setCarYear ] = useState('');
  const [ carPlate, setCarPlate ] = useState('');
  const [ carOdometer, setCarOdometer ] = useState('');
  const [ orderServices, setOrderServices ] = useState([]);
  const [ orderMechanics, setOrderMechanics ] = useState([]);

  const [ loadingFromDraft, setLoadingFromDraft ] = useState(true);
  const [ errors, setErrors ] = useState([]);

  useEffect(() => {
      if (loadingFromDraft) {
        if (draft) {
          setCarMake(draft.carMake);
          setCarType(draft.carType);
          setCarYear(draft.carYear);
          setCarPlate(draft.carPlate);
          setCarOdometer(draft.carOdometer);
          setOrderServices(draft.orderServices);
          setOrderMechanics(draft.orderMechanics);
          setOrderData(draft);
        } else {
          setCarMake('');
          setCarType('');
          setCarYear('');
          setCarPlate('');
          setCarOdometer('');
          setOrderServices([]);
          setOrderMechanics([]);
          setOrderData(null);
        }
        // console.log(draft);
        setLoadingFromDraft(false);
      }
  }, []);


  useEffect(() => {
    const tmpErrors = [];
    if (orderData) {
      draftDispatch(saveDraft(orderData));


      if (orderData.carMake.trim() == "") tmpErrors.push('Car Make is required');
      if (orderData.carType.trim() == "") tmpErrors.push('Car Type is required');
      if (orderData.carYear.trim() == "") tmpErrors.push('Car Year is required');
      if (orderData.carPlate.trim() == "") tmpErrors.push('Car Plate is required');
      if (orderData.carOdometer.trim() == "") tmpErrors.push('Car Odometer is required');
      if (orderData.orderServices.length == 0) tmpErrors.push('Atleast 1 service is required');
      if (orderData.orderMechanics.length == 0) tmpErrors.push('Atleast 1 mechanic is required');
      
      setErrors(tmpErrors);
      // console.log(orderData);
    }
  }, [orderData]);

  // useEffect(() => {
  //   console.log(errors);
  // }, [errors]);


  useEffect(() => {
    if (loadingFromDraft) {
      // console.log('loading from draft');
      return;
    }
    
    setOrderData({
        carMake: carMake,
        carType: carType,
        carYear: carYear,
        carPlate: carPlate,
        carOdometer: carOdometer,
        orderServices: orderServices,
        orderMechanics: orderMechanics,
    });
  }, 
  [ 
    carMake,
    carType,
    carYear,
    carPlate,
    carOdometer,
    orderServices,
    orderMechanics,
  ]);

  // useEffect(() => {
  //   // console.log(orderServices);
  // }, [orderServices]);



  const onAddedServiceUpdate = (service) => {
    const tmp = [...orderServices];
    tmp.forEach((s, index) => {
        if (s.id == service.id) {
            tmp[index] = service;
        }
    });
    setOrderServices(tmp);
    // console.log(service);
  }

  const onRemoveService = (service) => {
    const tmp = orderServices.filter(os => os.id !== service.id);
    setOrderServices(tmp);
  }

  return (
    <Flex 
      flexDirection="row" 
      pt={{ base: "120px", md: "75px" }}
      overflow={"auto"}
      >

      <Flex 
        flexDirection="column" 
        flexBasis={"66.66%"}
        m={2}
        >
        
        <Card p="1.2rem">
          <CardBody
            p="0px"
            w="100%"
            h={{ sm: "auto", lg: "auto" }}
            position="relative"
            borderRadius="15px"
          >

            {/* Car DEtails */}
            <FormControl marginBottom="12px">
                <Text fontSize="sm" color="gray.400" fontWeight="bold" mb={4}>
                    VEHICLE DETAILS
                </Text>
                <Flex flexDirection="row" w="100%">
                    <Box pr="12px" width={{ md: "50%", sm: "100%" }}>
                        <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                            Make
                        </FormLabel>
                        <Input
                            borderRadius="15px"
                            mb="12px"
                            fontSize="sm"
                            type="text"
                            placeholder="Toyota"
                            size="md" 
                            isRequired={true}

                            value={carMake} 
                            onChange={e => setCarMake(e.target.value)}
                        />
                    </Box>

                    <Box pr="12px" width={{ md: "50%", sm: "100%" }}>
                        <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                            Type
                        </FormLabel>
                        <Input
                            borderRadius="15px"
                            mb="12px"
                            fontSize="sm"
                            type="text"
                            placeholder="Camry"
                            size="md" 
                            isRequired={true}
                            value={carType} 
                            onChange={e => setCarType(e.target.value)}
                        />
                    </Box>

                    <Box pr="12px" width={{ md: "50%", sm: "100%" }}>
                        <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                            Year
                        </FormLabel>
                        <Input
                            borderRadius="15px"
                            mb="12px"
                            fontSize="sm"
                            type="number"
                            placeholder="2020"
                            size="md" 
                            isRequired={true}
                            value={carYear} 
                            onChange={e => setCarYear(e.target.value)}
                        />
                    </Box>
                </Flex>

                <Flex flexDirection="row" w="100%">

                    
                    <Box pr="12px" width={{ md: "50%", sm: "100%" }}>
                        <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                            Plate #
                        </FormLabel>
                        <Input
                            borderRadius="15px"
                            mb="12px"
                            fontSize="sm"
                            type="text"
                            placeholder="1234-ABCD"
                            size="md" 
                            isRequired={true}
                            value={carPlate} 
                            onChange={e => setCarPlate(e.target.value)}
                        />
                    </Box>

                    <Box pr="12px" width={{ md: "50%", sm: "100%" }}>
                        <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                            Odometer
                        </FormLabel>
                        <Input
                            borderRadius="15px"
                            mb="12px"
                            fontSize="sm"
                            type="number"
                            placeholder="5000"
                            size="md" 
                            isRequired={true}
                            value={carOdometer} 
                            onChange={e => setCarOdometer(e.target.value)}
                        />
                    </Box>

                </Flex>
            </FormControl>

          </CardBody>
        </Card>

        <Card p="1.2rem" mt={4}>
          <CardBody
            p="0px"
            w="100%"
            h={{ sm: "auto", lg: "auto" }}
            position="relative"
            borderRadius="15px"
          >
            <Flex flexDirection="column" w="100%">
              <Text fontSize="sm" color="gray.400" fontWeight="bold">
                  ADDED SERVICES { orderServices.length > 0 ? `(${orderServices.length})` : "(None)"}
              </Text>
             
              { orderServices.map((service, sIndex) => {
                    return <Flex direction="column" w="100%" key={`service-toggle-${sIndex}`}>
                        <CustomizeService 
                          serviceData={service}
                          onDataUpdated={onAddedServiceUpdate}
                          onDelete={onRemoveService}
                        />
                    </Flex>
                  })
              }

            </Flex>

          </CardBody>
        </Card>


        <Card p="1.2rem" mt={4}>
          <CardBody
            p="0px"
            w="100%"
            h={{ sm: "auto", lg: "auto" }}
            position="relative"
            borderRadius="15px"
          >
            <Flex flexDirection="column" w="100%">
              <Text fontSize="sm" fontWeight="bold" width="100%">
                To enable fill up all inputs
              </Text>
              <Flex w="100%" flexDirection="column">
                { errors.length > 0 && <Text color="red" fontSize="sm">
                  {errors[0]}</Text> 
                }
              </Flex>
              <Flex flexDirection="row" w="100%">
                <Button
                    fontSize="10px"
                    type="button"
                    bg="teal.300"
                    w="33%"
                    h="45"
                    m="12px"
                    color="white"
                    _hover={{
                    bg: "teal.200",
                    }}
                    _active={{
                    bg: "teal.400",
                    }}
                    disabled={orderData == null 
                      || errors.length > 0
                    }
                    onClick={orderData == null 
                      || errors.length > 0 
                    ? null 
                    : () => onOpenViewEstimate(true)}
                >
                    VIEW QUOTATION
                </Button>
                
                <Button
                    fontSize="10px"
                    type="button"
                    bg="blue.300"
                    w="33%"
                    h="45"
                    m="12px"
                    color="white"
                    _hover={{
                    bg: "blue.200",
                    }}
                    _active={{
                    bg: "blue.400",
                    }}
                    tool
                    disabled={
                      orderData == null 
                      || errors.length > 0
                    }
                    onClick={orderData == null 
                      || errors.length > 0
                    ? null 
                    : () => onOpenCreate(true)}
                >
                    BUILD ORDER
                </Button>
              </Flex>
            </Flex>
          </CardBody>
        </Card>

      </Flex>

      <Flex 
        flexDirection="column" 
        flexBasis={"33.33%"}
        maxWidth={"33.33%"}
        m={2}
        >

        <Card p="1.2rem">
          <CardBody
            p="0px"
            w="100%"
            h={{ sm: "auto", lg: "auto" }}
            position="relative"
            borderRadius="15px" 
          >

            <EstimateMechanic 
              orderMechanics={orderMechanics}
              setOrderMechanics={setOrderMechanics}
            />

          </CardBody>
        </Card>

        <Card p="1.2rem" mt={4}>
          <CardBody
            p="0px"
            w="100%"
            h={{ sm: "auto", lg: "auto" }}
            position="relative"
            borderRadius="15px"
          >
      
          <EstimateService 
            orderServices={orderServices} 
            setOrderServices={setOrderServices}
          />
            

          </CardBody>
        </Card>

      </Flex>
    


      <ViewEstimate 
          isOpen={isOpenViewEstimate}
          onClose={onCloseViewEstimate}
          orderData={orderData}
      />

      <CreateOrder
          isOpen={isOpenCreate}
          onClose={onCloseCreate}
          orderData={orderData} 
      />
    </Flex>
  );
}
